import React from "react";
import { Route, Routes } from "react-router-dom";
import {
  BusinessType,
  PAGE_PORTAL_COMPANY,
  PAGE_PORTAL_EDUCATION,
  PAGE_PORTAL_FINANCE,
  PAGE_PORTAL_INVENTORY,
  PAGE_PORTAL_ORDERS,
  PAGE_PORTAL_PEOPLE_EMPLOYEES,
  PAGE_PORTAL_PROFILE,
  PAGE_PORTAL_STORE,
  PAGE_PORTAL_STORE_DETAILS,
  PAGE_PORTAL_STORES,
  PAGE_ROUTE_ABOUT,
  PAGE_ROUTE_CONTACT,
  PAGE_ROUTE_DOWNLOAD_APPS,
  PAGE_ROUTE_FAQ,
  PAGE_ROUTE_FORGOT_PASSWORD,
  PAGE_ROUTE_LOGIN,
  PAGE_ROUTE_REGISTRATION,
  PAGE_ROUTE_ROLES_AND_ACCESS,
  PAGE_ROUTE_USER_GUIDE,
  PAGE_ROUTE_ABOUT_PRODUCT,
  PAGE_ROUTE_LEARN_MORE_CATEGORIES,
  PAGE_ROUTE_FORGOT_PASSWORD_SOP,
  PAGE_ROUTE_MANAGE_PROFILE_SOP,
  PAGE_ROUTE_DASHBOARD_SOP,
  PAGE_ROUTE_MANAGE_STORES_SOP,
  PAGE_ROUTE_MANAGE_COMPANY_SOP,
  PAGE_ROUTE_ADD_CATEGORY_SOP,
  PAGE_ROUTE_ADD_PRODUCT_ITEM_SOP,
  PAGE_ROUTE_ADD_PRODUCT_SOP,
  PAGE_ROUTE_BLOG,
  PAGE_ROUTE_SOPS
} from "@kivunova/kivufrontendcommon";
import { LEARN_MORE_TOPICS } from "./components/PublicInfo/constants/learnMoreTopicContent";
import { ORDER_RUN_BOOK_GUIDES } from "./components/PublicInfo/constants/orderRunBooksGuideContent";
import PortalHomePage from "./components/Portal/PortalHomePage";
import Welcome from "./components/Welcome";
import Login from "./components/Login/Login";
import Registration from "./components/Registration/Registration";
import ForgotPasswordWrapper from "./components/ForgotPassword/ForgotPasswordWrapper";
import UserProfile from "./components/Profile/UserProfile";
import LanguageLayout from "./components/LanguageLayout";
import AppShell from "./components/AppShell/AppShell";
import EmployeeList from "./components/Employees/EmployeeList";
import EmployeeDetailPage from "./components/Employees/EmployeeDetailPage";
import CompanyProfile from "./components/Company/CompanyProfile";
import StoreDetailPage from "./components/Store/StoreDetailPage";
import StoreList from "./components/Store/StoreList";
import StoreView from "./components/Store/StoreView";
import DownloadAppsPage from "./components/DownloadApps/DownloadAppsPage";
import AboutPage from "./components/PublicInfo/AboutPage";
import FaqPage from "./components/PublicInfo/FaqPage";
import ContactPage from "./components/PublicInfo/ContactPage";
import UserGuidePage from "./components/PublicInfo/UserGuidePage";
import BlogPage from "./components/PublicInfo/BlogPage";
import LearnMoreTopicPage from "./components/PublicInfo/LearnMoreTopicPage";
import AccessManagementPage from "./components/PublicInfo/AccessManagementPage";
import ProductVsProductItemPage from "./components/PublicInfo/ProductVsProductItemPage";
import CategoriesLearnMorePage from "./components/PublicInfo/CategoriesLearnMorePage";
import ForgotPasswordSopPage from "./components/PublicInfo/ForgotPasswordSopPage";
import ManageProfileSopPage from "./components/PublicInfo/ManageProfileSopPage";
import DashboardSopPage from "./components/PublicInfo/DashboardSopPage";
import ManageStoresSopPage from "./components/PublicInfo/ManageStoresSopPage";
import ManageCompanySopPage from "./components/PublicInfo/ManageCompanySopPage";
import AddCategorySopPage from "./components/PublicInfo/AddCategorySopPage";
import AddProductSopPage from "./components/PublicInfo/AddProductSopPage";
import AddProductItemSopPage from "./components/PublicInfo/AddProductItemSopPage";
import OrderSopSubguidePage from "./components/PublicInfo/OrderSopSubguidePage";
import SopHubPage from "./components/PublicInfo/SopHubPage";
import PublicInfoFloatingActions from "./components/PublicInfo/PublicInfoFloatingActions";
import TetaAssistant from "./components/Assistant/TetaAssistant";
import IndustryRouteGuard from "./components/Guards/IndustryRouteGuard";
import EducationRoutes from "./components/Education/EducationRoutes";
import InventoryRoutes from "./ProductMFE/InventoryRoutes";
import OrderRoutes from "./OrderMFE/OrderRoutes";
import MembershipRoutes from "./MembershipMFE/MembershipRoutes";

const Routers = () => {
  return (
    <>
      <Routes>
        {/* Wrap language-specific routing */}
        <Route path="/:lang?" element={<LanguageLayout />}>
          {/* Public routes */}
          <Route index element={<Welcome />} />
          <Route path={PAGE_ROUTE_LOGIN} element={<Login />} />
          <Route path={PAGE_ROUTE_REGISTRATION} element={<Registration />} />
          <Route
            path={PAGE_ROUTE_DOWNLOAD_APPS}
            element={<DownloadAppsPage />}
          />
          <Route path={PAGE_ROUTE_ABOUT} element={<AboutPage />} />
          <Route path={PAGE_ROUTE_USER_GUIDE} element={<UserGuidePage />} />
          <Route path={PAGE_ROUTE_BLOG} element={<BlogPage />} />
          {LEARN_MORE_TOPICS.map((topic) => (
            <Route
              key={topic.id}
              path={topic.route}
              element={<LearnMoreTopicPage topicId={topic.id} />}
            />
          ))}
          <Route path={PAGE_ROUTE_FAQ} element={<FaqPage />} />
          <Route
            path={PAGE_ROUTE_ROLES_AND_ACCESS}
            element={<AccessManagementPage />}
          />
          <Route
            path={PAGE_ROUTE_ABOUT_PRODUCT}
            element={<ProductVsProductItemPage />}
          />
          <Route
            path={PAGE_ROUTE_LEARN_MORE_CATEGORIES}
            element={<CategoriesLearnMorePage />}
          />
          <Route path={PAGE_ROUTE_SOPS} element={<SopHubPage />} />
          <Route
            path={PAGE_ROUTE_FORGOT_PASSWORD_SOP}
            element={<ForgotPasswordSopPage />}
          />
          <Route
            path={PAGE_ROUTE_MANAGE_PROFILE_SOP}
            element={<ManageProfileSopPage />}
          />
          <Route
            path={PAGE_ROUTE_DASHBOARD_SOP}
            element={<DashboardSopPage />}
          />
          <Route
            path={PAGE_ROUTE_MANAGE_STORES_SOP}
            element={<ManageStoresSopPage />}
          />
          <Route
            path={PAGE_ROUTE_MANAGE_COMPANY_SOP}
            element={<ManageCompanySopPage />}
          />
          <Route
            path={PAGE_ROUTE_ADD_CATEGORY_SOP}
            element={<AddCategorySopPage />}
          />
          <Route
            path={PAGE_ROUTE_ADD_PRODUCT_SOP}
            element={<AddProductSopPage />}
          />
          <Route
            path={PAGE_ROUTE_ADD_PRODUCT_ITEM_SOP}
            element={<AddProductItemSopPage />}
          />
          {ORDER_RUN_BOOK_GUIDES.map((guide) => (
            <Route
              key={guide.id}
              path={guide.route}
              element={<OrderSopSubguidePage guideId={guide.id} />}
            />
          ))}
          <Route path={PAGE_ROUTE_CONTACT} element={<ContactPage />} />
          <Route
            path={PAGE_ROUTE_FORGOT_PASSWORD}
            element={<ForgotPasswordWrapper />}
          />

          {/* Membership module — internal (outside AppShell) */}
          <Route path="membership/*" element={<MembershipRoutes />} />

          {/* Authenticated / portal routes */}
          <Route path="portal" element={<AppShell />}>
            <Route index element={<PortalHomePage />} />
            {/* ✅ Nested inside AppShell via <Outlet> */}
            <Route path={PAGE_PORTAL_PROFILE} element={<UserProfile />} />
            <Route path={PAGE_PORTAL_COMPANY} element={<CompanyProfile />} />
            <Route path={PAGE_PORTAL_STORE} element={<StoreView />} />
            {/* Product/Category/Stock routes — internal Inventory module */}
            <Route
              path={`${PAGE_PORTAL_INVENTORY}/*`}
              element={<InventoryRoutes />}
            />
            <Route
              path={PAGE_PORTAL_PEOPLE_EMPLOYEES}
              element={<EmployeeList />}
            />
            <Route
              path={`${PAGE_PORTAL_PEOPLE_EMPLOYEES}/:employeeId`}
              element={<EmployeeDetailPage />}
            />
            <Route path={PAGE_PORTAL_STORES} element={<StoreList />} />
            <Route
              path={PAGE_PORTAL_STORE_DETAILS}
              element={<StoreDetailPage />}
            />

            <Route
              path={`${PAGE_PORTAL_EDUCATION}/*`}
              element={
                <IndustryRouteGuard requiredType={BusinessType.EDUCATION}>
                  <EducationRoutes />
                </IndustryRouteGuard>
              }
            />

            {/* Order/Invoice/Payment/Receipt routes — internal Order module */}
            <Route path={`${PAGE_PORTAL_ORDERS}/*`} element={<OrderRoutes />} />
            <Route
              path={`${PAGE_PORTAL_FINANCE}/*`}
              element={<OrderRoutes />}
            />
          </Route>
        </Route>

        {/* Fallback route */}
        <Route path="*" element={<div>Page not found!</div>} />
      </Routes>
      <PublicInfoFloatingActions />
      <TetaAssistant />
    </>
  );
};

export default Routers;
